/* eslint-disable */
/* Автогенерация: npm start / npm run build → scripts/write-app-version.cjs */
export const CLIENT_BUILD_ID = "mrm7u00m-73eccdde311f5fe3";
export const CLIENT_APP_VERSION = "1.0.1";
